var getInstantiatorFunction = require('./getInstantiatorFunction')

module.exports = function(fn, args){
	return getInstantiatorFunction(args.length)(fn, args)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/newify/index.js
// module id = 570
// module chunks = 0